import { Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { isLargeScreen } from '../../../../../../global.variable';
import { AppService } from '../../../../../app.service';
import { UserProfileService } from '../../../../../profile/user-profile/user-profile.service';
import { AddEditSiteComponent } from '../../../../../shared/components/add-edit-site/add-edit-site.component';
import { CompanyLicencePromptComponent } from '../../../../../shared/components/company-licence-prompt/company-licence-prompt.component';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ContactComponent } from '../../../../../shared/components/contact/contact.component';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../../../../../shared/components/view-user-detail/view-user-detail.component';
import { DataCheckService } from '../../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { ClientsService } from '../../../clients/clients.service';
import { UsersService } from '../../../users/users.service';
import { JobsService } from '../../jobs.service';

@Component({
  selector: 'gtapp-casual-patrol',
  templateUrl: './casual-patrol.component.html',
  styleUrl: './casual-patrol.component.scss',
  standalone: false,
})
export class CasualPatrolComponent implements OnInit {
  @Input() selectedJobType: any;

  adHocFormData = new UntypedFormGroup({
    clientName: new UntypedFormControl('', Validators.required),
    siteName: new UntypedFormControl('', Validators.required),
    siteContactName: new UntypedFormControl(''),
    monitoringCompanyName: new UntypedFormControl(''),
    responseTypeName: new UntypedFormControl(''),
    assigneeName: new UntypedFormControl(),
    requestDetail: new UntypedFormControl(),
    internal_notes: new UntypedFormControl(),
    externalJobId: new UntypedFormControl(),
  });

  isAdmin: boolean = false;
  showSiteContactList: boolean = false;
  isDispatchUser: boolean = false;
  siteLicenceReminderCheck: boolean = false;
  licenseReminderField: boolean = false;
  showSiteMap: boolean = false;
  addJobPressed: boolean = false;
  selectedClient: any;
  adHocJobType: any = {
    jobType: {
      name: 'job Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    client: {
      name: 'Client',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    site: { name: 'Site', value: '', edit: false, data: null, tempValue: '' },
    assignee: {
      name: 'Assignee',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    ai: {
      name: 'Additional Information',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    in: {
      name: 'Internal Notes',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    eI: {
      name: 'Job Number',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    oc: {
      name: 'On Site Contact',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    rt: {
      name: 'Response Type',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
    mc: {
      name: 'Monitoring Company',
      value: '',
      edit: false,
      data: null,
      tempValue: '',
    },
  };

  sealInfo: any = {};

  clientList: any = [];
  siteList: any = [];
  siteContacts: any = [];
  assigneeList: any = [];

  responseTypeList: any = [];
  monitoringCompanyList: any = [];
  companyLicenseStateList: any = [];
  dialogRef: any;
  userData: any;
  largeView: Boolean = isLargeScreen;

  dialogData: any;

  initialDataList: any = {};

  selectedSiteExtraDetails: any;
  siteKeyList: any = [];
  userDetailPopoverTemplate = ViewUserDetailComponent;
  validAssigneeCheckDict: any = {};
  constructor(
    private viewContainerRef: ViewContainerRef,
    private _location: Location,
    private jobService: JobsService,
    private profileService: UserProfileService,

    private dialogService: ModalDialogueService,
    private clientService: ClientsService,
    private appService: AppService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private spinnerService: LoadingSpinnerService,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
    private userService: UsersService,
  ) {
    this.userData = this.appService.getUserData();
    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatchUser = this.dataCheckService.isDispatchUser();

    this.siteLicenceReminderCheck = this.userData?.checks?.license_reminder;

    router.events.subscribe((event: any) => {
      // close dialog boxes if any are open when back is pressed
      if (event.navigationTrigger === 'popstate') {
        this.dialogRef?.close();
      }
    });
  }

  ngOnInit(): void {
    this.adHocJobType.jobType.value = this.selectedJobType?.name;
    this.adHocJobType.jobType.data = this.selectedJobType;
    this.getMonitoringCompanyList();
    this.getResponseTypes();
    this.shiftFocus('siteId');

    this.onSiteSearch('');

    let fromSiteInfo = JSON.parse(sessionStorage.getItem('fromSite') || '{}');
    if (Object.keys(fromSiteInfo).length) {
      const siteData = {
        company_name: fromSiteInfo?.site?.company_name,
        id: fromSiteInfo?.site?.id,
        company: {
          company_name: fromSiteInfo?.client?.company_name,
          id: fromSiteInfo?.client?.id,
        },
      };
      this.onSelectSite(siteData);

      sessionStorage.removeItem('fromSite');
    }
    if (this.siteLicenceReminderCheck && this.isAdmin) {
      this.getCompanyLicenses();
    }
  }

  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';
    this.adHocJobType.site.tempValue = searchString;

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.siteList = res?.data?.splice(0, 10);

          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteList),
            );
          }
        }
      });
  }

  editField(field: string) {
    if (field == 'site') {
      this.adHocJobType.site = {
        name: 'Site',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocJobType.client = {
        name: 'Client',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocJobType.oc = {
        name: 'On Site Contact',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocJobType.assignee = {
        name: 'Assignee',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocJobType.mc = {
        name: 'Monitoring Company',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['monitoringCompanyName'].setValue(null);
      this.adHocFormData.controls['assigneeName'].setValue(null);
      this.adHocFormData.controls['clientName'].setValue(null);
      this.adHocFormData.controls['siteName'].setValue(null);
      this.adHocFormData.controls['siteContactName'].setValue(null);
      this.shiftFocus('siteId');
    }
    if (field == 'assignee') {
      this.adHocJobType.assignee = {
        name: 'Assignee',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['assigneeName'].setValue(null);

      this.shiftFocus('assigneeId');
    }
    if (field == 'rt') {
      this.adHocJobType.rt = {
        name: 'Response Type',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['responseTypeName'].setValue(null);
      this.shiftFocus('rtId');
    }
    if (field == 'mc') {
      this.adHocJobType.mc = {
        name: 'Monitoring Company',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['monitoringCompanyName'].setValue(null);
      this.shiftFocus('mcId');
    }
    if (field == 'oc') {
      this.adHocJobType.oc = {
        name: 'On Site Contact',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['siteContactName'].setValue(null);
      this.shiftFocus('ocId');
    }
    this.updateInitialDataList(field);
  }
  updateInitialDataList(field: any) {
    setTimeout(() => {
      if (field === 'assignee') {
        this.assigneeList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'site') {
        this.siteList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'rt') {
        this.responseTypeList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'mc') {
        this.monitoringCompanyList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }

      this.cdr.detectChanges();
    }, 200);
  }

  async onSelectSite(data: any) {
    if (data?.key === 0) {
      this.openAddSiteForm();
    }

    if (data?.id) {
      this.validAssigneeCheckDict = {};
      this.adHocJobType.oc = {
        name: 'On Site Contact',
        value: '',
        edit: false,
        data: null,
        tempValue: '',
      };
      this.adHocFormData.controls['siteContactName'].setValue(null);
      this.showSiteMap = true;
      this.adHocJobType.site.value = data?.company_name;
      this.adHocJobType.site.data = data;
      this.adHocFormData.controls['siteName'].setValue(data?.company_name);
      if (data?.company) {
        this.adHocJobType.client.value = data?.company?.company_name;
        this.adHocJobType.client.data = data?.company;
        this.adHocFormData.controls['clientName'].setValue(data?.company_name);
      }

      this.getSiteContacts(data?.id);
      this.findSelectedSiteAddInfo(data?.id);
      this.updateInitialDataList('assignee');
    }
  }

  openAddSiteForm() {
    const dialogRef = this.dialogService.open(AddEditSiteComponent, {
      data: {
        detailData: { company_name: this.adHocJobType.site.tempValue },
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data !== 'close') {
        this.onSelectSite(data);
      } else {
        this.editField('site');
      }
    });
  }
  getSiteContacts(id: any) {
    this.clientService.getSiteContacts(id).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.siteContacts = response['data'];
      } else {
        this.toasterService.setMessage({
          errorMessage: 'ERROR MESSAGE',
          successMessage: '',
        });
      }
    });
  }
  selectContact(contact: any) {
    if (contact.key == 0) {
      this.addNewContactForm();
    }
    if (contact?.id) {
      this.adHocJobType.oc.value = contact?.full_name;
      this.adHocJobType.oc.data = contact;
      this.adHocFormData.controls['siteContactName'].setValue(
        contact?.full_name,
      );
    }
  }
  addNewContactForm() {
    if (this.adHocJobType.site.data) {
      let siteData: any = this.adHocJobType.site.data;
      siteData['contacts'] = this.siteContacts;
      this.dialogRef = this.dialogService.open(ContactComponent, {
        data: {
          siteData: siteData,
          addNewSiteContact: true,
          contactType: 'lc',
        },
      });
      this.dialogRef.afterClosed().subscribe((value: any) => {
        if (value && value?.length) {
          this.siteContacts = value;

          let lastAddedContact =
            this.siteContacts[this.siteContacts?.length - 1];
          if (lastAddedContact) this.selectContact(lastAddedContact);
        }
      });
    }
  }

  onAssigneeSearch(event: any) {
    if (event.target.value?.length > 0) {
      this.getAssignees({ search_str: event?.target?.value });
    } else {
      this.updateInitialDataList('assignee');
    }
  }

  getAssignees(params?: any) {
    const reqParams = params || {};
    let reqBody: any = {};

    if (this.selectedSiteExtraDetails?.last_assignees) {
      const assigneeIds = Object.keys(
        this.selectedSiteExtraDetails?.last_assignees || {},
      );

      if (assigneeIds?.length)
        reqBody.sort_assignee_ids = assigneeIds?.slice(0, 5);
    }
    if (this.selectedSiteExtraDetails?.preferred_user_ids) {
      const assigneeIds =
        this.selectedSiteExtraDetails?.preferred_user_ids || [];

      if (assigneeIds?.length) reqBody.preferred_user_ids = assigneeIds;
    }
    this.jobService
      .getUserList(reqParams, reqBody)
      .subscribe(async (response: any) => {
        if (response['status'] == 'success') {
          const paramsPresent = params && Object.keys(params)?.length;

          if (!paramsPresent) {
            this.initialDataList.assignee = JSON.parse(
              JSON.stringify(response?.data),
            );
          }

          setTimeout(() => {
            this.assigneeList = JSON.parse(JSON.stringify(response?.data));
            this.cdr.detectChanges();
          }, 50);
        }
      });
  }
  assigneeSelected(assignee: any) {
    this.adHocJobType.assignee.value = assignee?.full_name;
    this.adHocJobType.assignee.data = assignee;
    this.adHocFormData.controls['assigneeName'].setValue(assignee?.full_name);
    this.shiftFocus('rtId');
  }
  async checkValidCredentialsForAssignee(assigneeId: string) {
    return new Promise((resovle) => {
      this.spinnerService.show('Checking Guard Credentials');

      const stateCode =
        this.selectedSiteExtraDetails?.state_code?.toLowerCase();
      const stateName =
        this.selectedSiteExtraDetails?.state_name?.toLowerCase();

      let stateArrays = [];

      if (stateCode)
        stateArrays.push(stateCode?.toLowerCase(), stateCode?.toUpperCase());
      if (stateName)
        stateArrays.push(stateName?.toLowerCase(), stateName?.toUpperCase());
      stateArrays = [...new Set(stateArrays)];
      if (stateArrays?.length) {
        this.userService
          .getUserById(assigneeId, {
            valid_cred_check: 1,
            states: JSON.stringify(stateArrays),
          })
          .subscribe((response: any) => {
            resovle(response?.data || false);
            this.spinnerService.hide();
          });
      } else {
        resovle(true);
      }
    });
  }
  async onAssigneeSelect(assignee: any) {
    if (assignee?.id) {
      this.adHocFormData.controls['assigneeName'].setValue(assignee?.full_name);

      let validAssignee: any = false;

      if (assignee?.id in this.validAssigneeCheckDict) {
        validAssignee = this.validAssigneeCheckDict[assignee?.id];
      } else {
        validAssignee = await this.checkValidCredentialsForAssignee(
          assignee?.id,
        );
      }

      this.validAssigneeCheckDict[assignee?.id] = validAssignee;
      if (validAssignee) {
        this.assigneeSelected(assignee);
      } else {
        let dialogMsg;
        if (this.userData.profile.email === assignee.email) {
          dialogMsg =
            'You may not hold the requried credentials (e.g. Security Licence, Police Checks, etc...) for this job. You can upload your credentials under your profile settings, or ignore this message.';
        } else {
          dialogMsg = `${
            assignee.full_name || assignee.email
          } may not hold the appropriate credentials (e.g. Security Licence) for this job. Ignore?`;
        }

        this.dialogData = { title: '', message: dialogMsg };
        this.dialogRef = this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Job Assignment',
            message: dialogMsg,
          },
        });
        this.dialogRef.afterClosed().subscribe((value: any) => {
          if (value === true) {
            this.assigneeSelected(assignee);
          } else {
            this.editField('assignee');
          }
        });
      }
    }
  }
  onAddJob() {
    this.addJobPressed = true;
    this.spinnerService.show();
    let data = {
      job_type_id: this.selectedJobType.id,
      company_id: this.adHocJobType?.client?.data?.id,
      location: [this.adHocJobType?.site?.data?.id],
      is_abandoned: false,
      request: this.adHocFormData.value.requestDetail,
      internal_notes: this.adHocFormData.value.internal_notes,
      new_assignee: this.adHocJobType?.assignee?.data?.id,
      location_contact_id: this.adHocJobType?.oc?.data?.id,
      monitoring_company_id: this.adHocJobType?.mc?.data?.id,
      response_type_id: this.adHocJobType?.rt?.data?.id,
      external_job_id: this.adHocFormData.value.externalJobId,
      seal_info: this.sealInfo,
    };
    this.jobService
      .createJob(data)
      .then((res: any) => {
        if (res['status'] == 'success') {
          this._location.back();
        } else {
          this.addJobPressed = false;
          this.toasterService.setMessage({
            errorMessage: res['message'],
            successMessage: '',
          });
          this.spinnerService.hide();
        }
      })
      .catch((error: any) => {
        if (error) {
          this.addJobPressed = false;
        }
      });
  }

  shiftFocus(elementId: string, timeout = 50) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, timeout);
  }

  openTemplate(template: any, _type: string) {
    this.dialogRef = this.dialogService.open(
      template,
      { data: _type },
      this.viewContainerRef,
    );
  }
  doSiteLicenseCheck() {
    const stateCode = this.selectedSiteExtraDetails?.state_code?.toLowerCase();
    const stateName = this.selectedSiteExtraDetails?.state_name?.toLowerCase();

    const stateCompanyLicencePresent = this.companyLicenseStateList?.some(
      (i: any) =>
        i?.toLowerCase() == stateCode || i?.toLowerCase() == stateName,
    );

    if (stateCompanyLicencePresent) {
      this.focustMcField();
    } else {
      const dialogRef = this.dialogService.open(
        CompanyLicencePromptComponent,
        {
          data: { credentialState: stateName || stateCode },
        },
        this.viewContainerRef,
      );
      dialogRef.afterClosed().subscribe((res: any) => {
        this.siteLicenceReminderCheck = false;
        this.focustMcField();
      });
    }
  }
  focustMcField() {
    setTimeout(() => {
      if (!this.adHocJobType.mc.data?.id) {
        this.shiftFocus('mcId');
      } else {
        this.shiftFocus('jobNumber');
      }
    }, 500);
  }

  getCompanyLicenses() {
    let params = { credential_check: 1 };
    this.profileService
      .fetchCompanyDetails(params)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.userData['checks']['license_reminder'] =
            response?.data?.license_reminder;
          this.siteLicenceReminderCheck = response?.data?.license_reminder;
          this.appService.setUserData(this.userData);
          this.companyLicenseStateList =
            response?.data?.credential_states || [];
        }
      });
  }

  onRtSearch(event: any) {
    this.adHocJobType.rt.tempValue = event.target.value;

    if (event.target.value.length) {
      this.responseTypeList = this.initialDataList?.rt?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.responseTypeList = this.initialDataList?.rt || [];
    }
  }

  getResponseTypes(params?: any) {
    this.clientService.fetchResponseTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.responseTypeList = res['data'];

        this.initialDataList.rt = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onMonitoringSelect(company: any) {
    if (company.key === 0) {
      this.openAddMonitoringCompany();
    }
    if (company?.id) {
      this.adHocFormData.controls['monitoringCompanyName'].setValue(
        company?.company_name,
      );

      this.adHocJobType.mc.value = company?.company_name;
      this.adHocJobType.mc.data = company;
      this.shiftFocus('jobNumber');
    }
  }
  openAddMonitoringCompany() {
    if (this.adHocJobType.mc.tempValue?.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createMonitoringCompany({
          company_name: String(this.adHocJobType.mc.tempValue),
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onMonitoringSelect(response?.data);
            this.toasterService.setMessage({
              errorMessage: '',
              successMessage: response['message'],
            });
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Monitoring Company value can't be empty",
        successMessage: '',
      });
    }
  }
  onResponseTypeSelect(responseType: any) {
    if (responseType.key === 0) {
      this.openAddResponseType();
    }
    if (responseType?.id) {
      this.adHocFormData.controls['responseTypeName'].setValue(
        responseType?.name,
      );
      this.adHocJobType.rt.value = responseType?.name;
      this.adHocJobType.rt.data = responseType;
    }
  }
  openAddResponseType() {
    if (this.adHocJobType.rt.tempValue?.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createResponseType({ name: String(this.adHocJobType.rt.tempValue) })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onResponseTypeSelect(response?.data);
            this.getResponseTypes();
            this.toasterService.setMessage({
              errorMessage: '',
              successMessage: response['message'],
            });
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Response Type value can't be empty",
        successMessage: '',
      });
    }
  }
  onMcSearch(event: any) {
    // in case add client auto fill the form
    this.adHocJobType.mc.tempValue = event.target.value;
    if (event?.target?.value.length > 0) {
      this.getMonitoringCompanyList({ search_str: event?.target?.value });
    }
    this.adHocJobType.mc.value = null;
    this.adHocJobType.mc.data = null;
  }
  getMonitoringCompanyList(params?: any) {
    this.clientService
      .fetchMonitoringCompanyList(params)
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.monitoringCompanyList = res['data'];
          if (!params) {
            this.initialDataList.mc = JSON.parse(JSON.stringify(res?.data));
          }
        }
      });
  }
  updateJobExtraInfo(_type: string) {
    if (_type === 'ai') {
      this.adHocFormData.controls['requestDetail'].setValue(
        this.adHocJobType?.ai?.value,
      );
    } else {
      this.adHocFormData.controls['internal_notes'].setValue(
        this.adHocJobType?.in?.value,
      );
    }
  }
  siteKeyInternalCheck(siteKeyListData: any) {
    this.siteKeyList = siteKeyListData;
    this.sealInfo = {
      internal_check: Boolean(this.siteKeyList?.length),
    };
  }
  findSelectedSiteAddInfo(siteId: string) {
    this.selectedSiteExtraDetails = {};

    this.spinnerService.show();
    this.jobService
      .fetchJobDetails(
        { site_id: siteId, job_type_id: this.selectedJobType?.id },
        { additional_site_info: 1, last_mc_for_site: 1, get_last_assignees: 1 },
      )
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.selectedSiteExtraDetails = response?.data;
          this.getAssignees();

          if (this.selectedSiteExtraDetails?.mc_data?.id) {
            this.onMonitoringSelect(this.selectedSiteExtraDetails?.mc_data);
          }

          if (this.siteLicenceReminderCheck && this.isAdmin == true) {
            this.doSiteLicenseCheck();
          } else {
            this.shiftFocus('mcId');
          }
        } else {
          this.getAssignees();
        }
        this.spinnerService.hide();
      });
  }
}
